export interface StockyReconciliationResults {
  unreconciled: number;
  totalStockyPOs: number;
  orphansRecovered: number;
}

/**
 * Human-readable summary of the Stocky PO reconciliation result shown on the
 * migration completion screen.
 */
export function stockyReconciliationText(r: StockyReconciliationResults): string {
  return r.unreconciled > 0
    ? `${r.unreconciled} of ${r.totalStockyPOs} Stocky POs were not imported`
    : `All ${r.totalStockyPOs} Stocky POs accounted for`;
}
